// @flow
export const APP_MAX_WIDTH = '500px';
export const BOTTOM_NAV_HEIGHT = 60;
export const MAX_UPI_TIMER = 1000 * 60 * 5;
export const VSHELF_MACHINE_SKU = 'add_to_cart_from_machine_shelf';
export const NOTIFY_ACTION = 'notify_me';
export const VIRTUAL_ORDER = 'vsorder';
export const MACHINE_ORDER = 'app';
export const KIOSK_ORDER = 'kiosk';

// order status
export const COMPLETED_ORDER = 'Completed';
export const CANCELLED_ORDER = 'Cancelled';
export const CONFIRMED_ORDER = 'Confirmed';
export const DELIVERED_ORDER = 'Delivered';
// export const IN_PROGRESS_ORDER = 'in_progress';
export const ACTIVE_ORDER = 'active';
export const PARTIAL_DELIVERED_ORDER = 'partial';
export const PICKED_UP = 'Picked Up';
export const RECEIVED_ORDER = 'received';
export const FAILED_ORDER = 'Failed';
export const PARTIAL_ORDER = 'Partial';
// end order status

export const ORDER_STATUS = {
	active: 'Active',
	in_progress: 'In Progress',
	Confirmed: 'Confirmed',
	Completed: 'Completed',
	Cancelled: 'Cancelled',
	partial: 'Partial',
	received: 'Received',
	'Picked Up': 'Picked Up',
	Partial: 'Partial',
	Failed: 'Failed',

};

export const SIGNUP_PAGE = 'SIGNUP_PAGE';
export const SIGNUP_DIALOG = 'SIGNUP_DIALOG';

export const GUEST_ROUTES = ['/browse', '/product', '/podlist', '/affiliate'];

export const ADD_LOCATION_REQUEST = 'ADD_LOCATION_REQUEST';
export const NOTIFY_WHEN_MACHINE_PICKUP_AVAILABLE = 'NOTIFY_WHEN_MACHINE_PICKUP_AVAILABLE';
export const PRODUCT_SUGGESTION = 'PRODUCT_SUGGESTION';

export const VSHELF_MASTER_LIST = '0';
export const MACHINE_SHELF = '-1';

export const SHELF = 'virtual_shelf';
export const CATEGORY = 'category';
export const SKU = 'sku';
export type VIEW_TYPE = 'virtual_shelf' | 'category' | 'sku';

export const EXPRESS_DELIVERY = 'Express Delivery';
export const MACHINE_PICKUP = 'Machine';

export type SKU_LIST_TYPE = 'Express Delivery' | 'Machine';

// affiliate
export const AFFILIATE_ACTIVE = 'affiliate-active';
export const AFFILIATE_DATA = 'affiliate-data';

export const MAX_DISTANCE = 5000;

export const CIGARETTE_SUB_CATEGORY = 'Paan Store';
export const PAAN_STORE = 'NU12202099';
export const PAAN_STORE_DATA = {
	address: 'HSR LAYOUT',
	area: 'Bangalore',
	cart_enabled: true,
	ds_area: 'Bangalore',
	ds_geocode: '12.9158,77.6343',
	ds_imei: 'NU12202099',
	latlong: '12.9158,77.6343',
	location: 'TinyMart Paan Shop',
	vm_id: '8969790716036205555',
	vm_imei_id: 'NU12202099',
};

export const MARATHALLI_STORE = 'NU11202098';